export const INITIAL_PACKAGES = [
  {
    id: 'fw-ws-638-production',
    deviceModel: 'WallStation',
    hardwareVersion: 'ESP32',
    firmwareVersion: '6.3.8',
    channel: 'PRODUCTION',
    sizeInBytes: 1455718,
    releaseDate: 'Jul 25, 2026',
    createdAt: 'Jul 23, 2026',
    summary: 'Stability and remote-control compatibility improvements.',
    availability: [
      { region: 'EU Central 1', audience: 'All eligible devices', state: 'Active' },
      { region: 'US East 1', audience: 'All eligible devices', state: 'Active' },
    ],
  },
  {
    id: 'fw-ws-637-beta',
    deviceModel: 'WallStation',
    hardwareVersion: 'ESP32',
    firmwareVersion: '6.3.7',
    channel: 'BETA',
    sizeInBytes: 1439307,
    releaseDate: 'Jul 17, 2026',
    createdAt: 'Jul 16, 2026',
    summary: 'Early-release validation package for selected field devices.',
    availability: [{ region: 'EU Central 1', audience: 'Pilot customer group', state: 'Active' }],
  },
  {
    id: 'fw-linear-824-alpha',
    deviceModel: 'Linear',
    hardwareVersion: 'ESP32',
    firmwareVersion: '8.2.4',
    channel: 'ALPHA',
    sizeInBytes: 1689600,
    releaseDate: 'Jul 11, 2026',
    createdAt: 'Jul 10, 2026',
    summary: 'Engineering validation package with diagnostic telemetry updates.',
    availability: [{ region: 'US East 1', audience: 'Engineering test devices', state: 'Active' }],
  },
  {
    id: 'fw-gdo-814-internal',
    deviceModel: 'Garage Door Opener',
    hardwareVersion: 'GDO v2',
    firmwareVersion: '8.1.4',
    channel: 'INTERNAL',
    sizeInBytes: 1376256,
    releaseDate: 'Jul 8, 2026',
    createdAt: 'Jul 8, 2026',
    summary: 'Internal package awaiting release review.',
    availability: [{ region: 'EU Central 1', audience: 'Internal validation', state: 'Limited' }],
  },
];

export const INITIAL_BATCHES = [
  {
    id: 'BATCH-EUC-2026-0718',
    region: 'EU Central 1',
    deviceModel: 'WallStation',
    firmwareVersion: '6.3.8',
    status: 'In progress',
    total: 240,
    queued: 80,
    active: 60,
    complete: 94,
    failed: 6,
    updated: '8 minutes ago',
  },
  {
    id: 'BATCH-USE1-2026-0714',
    region: 'US East 1',
    deviceModel: 'Linear',
    firmwareVersion: '8.2.3',
    status: 'Completed',
    total: 125,
    queued: 0,
    active: 0,
    complete: 123,
    failed: 2,
    updated: 'Jul 15, 2026',
  },
];
